import Layout from '@/pages/Layout';

export default [
    {
        path: '/application',
        redirect: 'noredirect',
        component: Layout,
        name: 'application',
        meta: {
            title: '设计中心',
            icon: 'el-icon-s-tools'
        },
        children: [
            {
                path: 'applicationDesignTitle',
                name: 'applicationDesignTitle',
                id: 'applicationDesignTitle',
                meta: {
                    title: '应用设计',
                    icon: 'iconfont icon-other-yingyong bc-custom-menu',
                    color: '#07c8f4'
                },
                sortOrder: 20,
                isDesign: true,
                isTitle: true,
                isShow: false,
                isMenuWaterfall:true
            },
            {
                pId: 'applicationDesignTitle',
                path: 'application-tree',
                component: () => import('@/pages/application/ApplicationTree'),
                name: 'application-tree',
                id: 'application/application-tree',
                meta: {
                    title: '应用配置',
                    icon: 'iconfont icon-other-NMStubiao- bc-custom-menu',
                    color: '#0df0e5'
                },
                sortOrder: 21,
                isDesign: true,
                isSubMenu: true,
                isMenuWaterfall:true
            },
            {
                path: 'application-config/:appId/:appName/:modelId',
                component: () => import('@/pages/application/ApplicationConfig'),
                isShow: false,
                name: 'application-config',
                id: 'application/application-config/:appId/:appName/:modelId',
                meta: {
                    title: '应用设计',
                    icon: 'iconfont icon-other-liuchengtu bc-custom-menu',
                    color: '#07c8f4'
                },
                sortOrder: 22,
                isDesign: true,
                isMenuWaterfall:true
            },
            {
                pId: 'applicationDesignTitle',
                path: 'model-config',
                component: () => import('@/pages/application/ModelConfig'),
                name: 'model-config',
                id: 'application/model-config',
                props: {
                    processType: 'edit'
                },
                meta: {
                    title: '模型配置',
                    icon: 'iconfont icon-other-moxing___ bc-custom-menu',
                    color: '#17f2c9'
                },
                sortOrder: 23,
                isDesign: true,
                isSubMenu: true,
                isMenuWaterfall:true
            },
            {
                pId: 'applicationDesignTitle',
                path: 'model-assign',
                component: () => import('@/pages/application/ApplicationAssign'),
                name: 'model-assign',
                id: 'application/model-assign',
                meta: {
                    title: '模型授权',
                    icon: 'iconfont icon-other-shouquan bc-custom-menu',
                    color: '#65e8cf'
                },
                sortOrder: 24,
                isDesign: true,
                isSubMenu: true,
                isMenuWaterfall:true
            },
            {
                path: 'cronjob-config', // 资源路径
                component: () => import('@/pages/application/Cronjob/CronjobList'),
                name: 'cronjob-config',
                id: 'application/cronjob-config', // 资源描述
                isOffice: true,
                meta: {
                    title: '定时任务',
                    icon: 'iconfont icon-other-wulumuqishigongandashujuguanlipingtai-ico- bc-custom-menu',
                    color: '#f20070'
                },
                isMenuWaterfall:true
            },
            {
                path: 'cronjob-add/:jobId',
                component: () => import('@/pages/application/Cronjob/CronjobDetail'),
                isShow: false,
                name: 'cronjobAdd',
                id: 'application/cronjob-add/:jobId',
                meta: {
                    title: '新增定时任务',
                    icon: 'beer'
                },
                isMenuWaterfall:false
            },
            {
                path: 'model-edit/:formId',
                component: () => import('@/pages/application/ModelConfig/ModelAdd'),
                isShow: false,
                // redirect: 'noredirect',
                name: 'modelEdit',
                id: 'application/model-edit/:formId',
                meta: {
                    title: '修改模型表单',
                    icon: 'table'
                },
                isMenuWaterfall:false
            },
            {
                path: 'model-add/:appId/:appName/:modelType',
                component: () => import('@/pages/application/ModelConfig/ModelAdd'),
                isShow: false,
                name: 'modelAdd',
                id: 'application/model-add/:appId/:appName/:modelType',
                meta: {
                    title: '添加模型表单',
                    icon: 'table'
                },
                isMenuWaterfall:false
            },
            {
                path: 'notice-list', // 公告管理
                component: () => import('@/pages/application/Notice'),
                name: 'notice-list',
                id: 'application/notice-list', // 公告管理
                isOffice: true,
                meta: {
                    title: '公告管理',
                    icon: 'iconfont icon-other-notice bc-custom-menu',
                    color: '#fc6004'
                },
                isMenuWaterfall:true
            },
            {
                path: 'notice-edit', // 资源路径
                component: () => import('@/pages/application/Notice/NoticeEdit'),
                name: 'notice-edit',
                isShow: false,
                id: 'application/notice-edit/:id', // 资源描述
                meta: {
                    title: '编辑公告',
                    icon: 'beer'
                },
                isMenuWaterfall:false
            }
        ]
    }
];



// WEBPACK FOOTER //
// ./src/router/modules/route-application.js